import {
  generatedApi,
  useAccountControllerAccountQuery,
} from '@/services/generated/api';
import type {
  AccountResponseDto,
  AccountTenantDto,
  ApiKeySummaryDto,
} from '@/services/generated/api';

/**
 * The authenticated account (`GET /api/account`), over the generated client.
 *
 * It is also how the SPA starts its session: the request carries the `HttpOnly`
 * cookie, so a 200 means "there is a session" and a 401 means "go to the login".
 */
export const accountApi = generatedApi;

export const useGetAccountQuery = useAccountControllerAccountQuery;

export type Account = AccountResponseDto;
export type AccountTenant = AccountTenantDto;
export type AccountApiKey = ApiKeySummaryDto;
